import Login from "../pages/Login";
import Dashboard from "../features/Dashboard";
import SignUp from "../pages/SignUp";
import CreatedRules from "../features/Rules";
import UserProfile from "../components/UserProfile";
import Users from "../features/Users";
import Account from "../components/Account";
import Admin from "../features/admin";
import Usage from "../components/Usage";
export const routes = [
  {
    path: "/portal/profile",
    element: <UserProfile />,
    isPrivate: true,
  },
  {
    path: "/portal/admin",
    element: <Admin />,
    isPrivate: true,
  },
  {
    path: "/portal/account",
    element: <Account />,
    isPrivate: true,
  },
  {
    path: "/portal/dashboard",
    element: <Dashboard />,
    isPrivate: true,
  },
  {
    path: "/portal/users",
    element: <Users />,
    isPrivate: true,
    permission: "Onboarding Manager",
  },
  {
    path: "/portal/mappings",
    element: <CreatedRules />,
    isPrivate: true,
  },
  {
    path: "/portal/plan",
    element: <Usage />,
    isPrivate: true,
  },

  { path: "/portal/signup", element: <SignUp />, isPrivate: false },
  { path: "/portal/login", element: <Login />, isPrivate: false },
];
